import { parse } from "@aws-sdk/util-arn-parser";
import * as Sentry from "@sentry/browser";

import { TableLink } from "./TableLink";

interface Props {
  resourceKey: string;
  resourceName?: string;
  truncate?: boolean;
  copyLabel?: string;
}

export function ResourceLink({
  resourceKey,
  resourceName,
  truncate = false,
  copyLabel = "resource id",
}: Props) {
  let resource;

  try {
    const arn = parse(resourceKey);
    resource = arn.resource;
  } catch (e) {
    resource = resourceKey;
    Sentry.captureException(e);
  }

  return (
    <TableLink
      copyLabel={copyLabel}
      copyValue={resourceKey}
      description={resourceKey}
      name={resourceName || resource}
      to={`/cloudops/resources/${encodeURIComponent(resourceKey)}`}
      truncate={truncate}
      copyButton
    />
  );
}
